import React, { FC, useEffect, useMemo, useState } from "react";
import CommonMenuListPage from "../../../components/CustomMenuListPage/CommonMenuListPage";
import {
  Box,
  Divider,
  IconButton,
  ListItem,
  ListItemText,
  Typography,
  Collapse,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useLazyFetchFaqCategoriesQuery } from "../GeneralAppElements_Api";
import {
  T_FaqCategoryItems,
  T_FaqListItemList,
  T_FaqListItems,
  T_FaqModuleItem,
} from "../GeneralAppElements_Types";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../redux-store/CustomReduxHooks";
import { setError } from "../../../redux-store/reducers/CsErrorSlice";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import CustomThreeDotsLoader from "../../../components/CustomThreeDotsLoader/CustomThreeDotsLoader";
import { triggerCleverTapEvent } from "../../../utils/CleverTap";
import { CleverTapEventType } from "../../../utils/CleverTapConstant";
import { CT_ScreenEvntDtls } from "../../Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import {
  GTAScreenType,
  HiLobCode,
  HlLobCode,
  SCREEN_TYPE,
  LiLobCode,
} from "../../../utils/constants";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { isEmpty } from "lodash";
import TriggerGTAEvent from "../../../utils/GTA";
import { useHLBaseDataLoader } from "../../Feature_Homeloan/BaseDataInit/HomeLoan_Init_BaseData";
import useHflFaqApi from "../../../hooks/useHflFaqApi";
interface Props {
  handleBackBtnClick: Function;
  pathname?: string;
}

const FAQs: FC<Props> = ({ handleBackBtnClick, pathname }) => {
  const [state, setState] = useState<{
    parentModule: string;
    type: string;
    module: string;
    question: string;
    parentModuleName: string;
    moduleName: string;
    categoryName: string;
  }>({
    parentModule: "",
    type: "parent-module",
    module: "",
    question: "",
    parentModuleName: "",
    moduleName: "",
    categoryName: "",
  });
  const [fetchFaqCategories] = useLazyFetchFaqCategoriesQuery();
  const { callHflFaqCreateCaseApi, callParentModuleApi, callFetchFaqListApi } =
    useHflFaqApi();
  const [isCallHLApis, setIsCallHLApis] = useState<boolean>(false);
  const { isFetching: isHlFetching, error: hlError } = useHLBaseDataLoader(
    "",
    isCallHLApis,
    true
  );
  const [FAQCategory, setFAQCategory] = useState<T_FaqCategoryItems[]>([]);
  const [answers, setAnswers] = useState<T_FaqListItems[]>([]);
  const [FAQsHeaderText, setFAQsHeaderText] = useState<string[]>([
    "BROWSE CATEGORIES",
  ]);
  const [loading, setLoading] = useState<boolean>(false);
  const appDispatch = useAppDispatch();
  const parentModuleList = useAppSelector(
    (state) => state.GeneralAppElementsSlice.parentModuleList
  );
  const customerAndLobDetails = useAppSelector(
    (state) => state.CsAppSlice.userDetails?.customerAndLobDetails
  );
  const navigate = useNavigate();
  const location = useLocation();
  const [URLSearchParam] = useSearchParams();
  const action = URLSearchParam.get("action") || "";
  const paramModule = URLSearchParam.get("module") || "";

  const isHlPrimaryDataExist = useMemo(() => {
    const filteredLobs = customerAndLobDetails?.filter(
      (lobDetail) =>
        HlLobCode === lobDetail.LOB &&
        lobDetail.PRIMARY_SECONDARY_USER === "primary"
    );
    return !isEmpty(filteredLobs);
  }, [customerAndLobDetails]);

  useEffect(() => {
    if (isEmpty(parentModuleList)) {
      callParentModuleApi(setLoading);
    }
  }, []);

  useEffect(() => {
    if (isHlPrimaryDataExist && state.module === "home-loan") {
      setIsCallHLApis(true);
    }
  }, [isHlPrimaryDataExist, state.module]);

  useEffect(() => {
    if (hlError) {
      setIsCallHLApis(false);
    }
  }, [hlError]);

  useEffect(() => {
    if (state.type === "parent-module") {
      handleClevertapEventtrigger(
        CT_ScreenEvntDtls.R_GAE.gaUtilitiesOptSelection.screenName
      );
    } else if (state.type === "module") {
      handleClevertapEventtrigger(
        CT_ScreenEvntDtls.R_GAE.gaFaqSubCategSelection.screenName
      );
    } else if (state.type === "category") {
      handleClevertapEventtrigger(
        CT_ScreenEvntDtls.R_GAE.gaFaqSubCategQueList.screenName
      );
    }
  }, [state.type]);

  useEffect(() => {
    let headers =
      state.parentModuleName === ""
        ? ["BROWSE CATEGORIES"]
        : [state.parentModuleName, state.moduleName, state.categoryName];

    setFAQsHeaderText(headers.filter((name) => name !== ""));
  }, [state.parentModuleName, state.categoryName, state.moduleName]);

  useEffect(() => {
    if (!isEmpty(parentModuleList) && action === "FAQs") {
      let parentItem: any;
      let moduleItem: any;
      if (paramModule === "lifeInsurance") {
        parentItem = parentModuleList.filter(
          (item) => item.attributes.key === "insurance"
        );
        moduleItem = parentItem[0].attributes.modules.data.filter(
          (item: T_FaqModuleItem) => item.attributes.lobId === LiLobCode
        );
      } else if (paramModule === "healthInsurance") {
        parentItem = parentModuleList.filter(
          (item) => item.attributes.key === "insurance"
        );
        moduleItem = parentItem[0].attributes.modules.data.filter(
          (item: T_FaqModuleItem) => item.attributes.lobId === HiLobCode
        );
      } else if (paramModule === "homeLoan") {
        parentItem = parentModuleList.filter(
          (item) => item.attributes.key === "loans"
        );
        moduleItem = parentItem[0].attributes.modules.data.filter(
          (item: T_FaqModuleItem) => item.attributes.lobId === HlLobCode
        );
      }
      setState((prevState) => ({
        ...prevState,
        module: moduleItem?.[0]?.attributes.key,
        moduleName: moduleItem?.[0]?.attributes?.moduleName,
        parentModuleName: parentItem?.[0]?.attributes.parentModuleName,
        parentModule: moduleItem?.[0]?.attributes.key,
        type: "module",
      }));
      fetchFaqCategory(moduleItem[0].attributes.key);
    }
  }, [parentModuleList]);

  const updateTitle = (type: string, name: string) => {
    if (type === "parent-module") {
      setState((prevState) => ({
        ...prevState,
        parentModuleName: name,
      }));
    } else if (type === "module") {
      setState((prevState) => ({
        ...prevState,
        moduleName: name,
      }));
    } else if (type === "category") {
      setState((prevState) => ({
        ...prevState,
        categoryName: name,
      }));
    }
  };

  const fetchFaqCategory = async (module: string) => {
    setLoading(true);
    try {
      const response = await fetchFaqCategories(module, true);
      if (response.data?.code === 1) {
        setFAQCategory(response.data.payload.data);
      } else {
        appDispatch(
          setError({
            error: response.data,
            message: "FAQ Api error",
          })
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCleverTapCTAClick = (itemSelected: string) => {
    triggerCleverTapEvent("serv_faq_cat_click", {
      ScreenName: "Servicing Faq Main Category Selection Screen",
      ScreenType: SCREEN_TYPE.generalAppType,
      isPrevPageNameRequired: true,
      FaqCategory: itemSelected,
    });
  };

  const handleGTMCTAClick = (itemSelected: string) => {
    TriggerGTAEvent("serv_faq_cat_click", {
      screen_type: GTAScreenType.DashboardScreenType,
      screen_name: "servicing_faq_main_category_selection_screen",
      faq_category: itemSelected,
    });
  };

  const handleFAQsClick = (key: string, type: string) => {
    setState((prevState) => ({
      ...prevState,
      parentModule:
        type === "parent-module" && key === prevState.parentModule ? "" : key,
      type: type,
      module: type === "module" ? key : prevState.module,
    }));
    if (type === "parent-module") {
      triggerCleverTapEvent("serv_faq_sub_cat_click", {
        ScreenType: SCREEN_TYPE.HIScreenType,
        ScreenName: "Servicing Faq Main Category Selection Screen",
        isPrevPageNameRequired: true,
        FaqCategory: "BROWSE CATEGORIES",
        FaqSubCategory: key,
      });
    } else if (type === "module") {
      triggerCleverTapEvent("serv_faq_sub_cat_click", {
        ScreenType: SCREEN_TYPE.HIScreenType,
        ScreenName: "Servicing Faq Main Category Selection Screen",
        isPrevPageNameRequired: true,
        FaqCategory: state.parentModuleName,
        FaqSubCategory: key,
      });
      TriggerGTAEvent("serv_faq_sub_cat_click", {
        screen_type: GTAScreenType.DashboardScreenType,
        screen_name: "servicing_faq_sub_category_selection_screen",
        faq_category: state.parentModuleName,
        faq_sub_category: key,
      });
    } else if (type === "category") {
      triggerCleverTapEvent("serv_faq_sub_cat_option_click", {
        ScreenType: SCREEN_TYPE.HIScreenType,
        ScreenName: "Servicing Faq Sub Category Selection Screen",
        isPrevPageNameRequired: true,
        FaqCategory: state.parentModuleName,
        FaqSubCategory: state.module,
        OptionSelected: key,
      });
      TriggerGTAEvent("serv_faq_sub_cat_option_click", {
        screen_type: GTAScreenType.DashboardScreenType,
        screen_name: "servicing_faq_sub_category_selection_screen",
        faq_category: state.parentModuleName,
        faq_sub_category: state.module,
        option_selected: key,
      });
    }

    if (type === "module") {
      fetchFaqCategory(key);
    } else if (type === "category") {
      callFetchFaqListApi(key, state.module, setLoading).then((data) =>
        setAnswers(data)
      );
    }

    const header = [
      state.parentModuleName,
      state.moduleName,
      state.categoryName,
    ];
    setFAQsHeaderText(header);
  };

  const showAnswer = (questionData: T_FaqListItemList) => {
    if (
      state.question !== questionData.question &&
      isHlPrimaryDataExist &&
      state.module === "home-loan"
    ) {
      callHflFaqCreateCaseApi(questionData);
    }
    setState((prevState) => ({
      ...prevState,
      question:
        state.question === questionData.question ? "" : questionData.question,
    }));
    triggerCleverTapEvent("serv_faq_question_click", {
      ScreenType: SCREEN_TYPE.HIScreenType,
      ScreenName: "SServicing Faq Sub Category Questions List Screen",
      isPrevPageNameRequired: true,
      FaqCategory: state.parentModuleName,
      FaqSubCategory: state.module,
      OptionSelected: state.parentModule,
      QuestionText: questionData.question,
    });
    TriggerGTAEvent("serv_faq_question_click", {
      screen_type: GTAScreenType.DashboardScreenType,
      screen_name: "servicing_faq_sub_category_questions_list_screen",
      faq_category: state.parentModuleName,
      faq_sub_category: state.module,
      option_selected: state.parentModule,
      question_text: questionData.question,
    });
  };

  const handleBack = () => {
    if (state.type === "category") {
      // Going back from category to module
      setState((prevState) => ({
        ...prevState,
        type: "module",
        categoryName: "",
        question: "",
      }));
    } else if (state.type === "module") {
      // Going back from module to parent module
      setState((prevState) => ({
        ...prevState,
        type: "parent-module",
        module: "",
        moduleName: "",
        categoryName: "",
        question: "",
        parentModuleName: "",
      }));
    } else {
      handleBackBtnClick();
    }
    if (action && module) {
      navigate(location.pathname, { replace: true });
    }
  };

  const handleClevertapEventtrigger = (screenName: string) => {
    triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
      ScreenName: screenName,
      ScreenType: SCREEN_TYPE.DashboardScreenType,
    });
  };
  const renderParentModuleView = () => (
    <>
      <CommonMenuListPage
        title="FAQs"
        handleBackBtnClick={handleBackBtnClick}
        pathname={pathname}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          paddingX="1.25rem"
        >
          <Divider className="header-text-line" />
          <Typography
            color="#77787B"
            fontSize=".75rem"
            fontWeight={500}
            marginX=".625rem"
          >
            {FAQsHeaderText.filter((name) => name !== "").join(" / ")}
          </Typography>
          <Divider className="header-text-line" />
        </Box>
        {!isEmpty(parentModuleList) &&
          parentModuleList.map((item) => (
            <React.Fragment key={item.attributes.parentModuleName}>
              <ListItem
                onClick={() => {
                  handleFAQsClick(item.attributes.key, "parent-module");
                  handleCleverTapCTAClick(item.attributes.parentModuleName);
                  handleGTMCTAClick(item.attributes.parentModuleName);
                  updateTitle(
                    "parent-module",
                    item.attributes.parentModuleName
                  );
                }}
                secondaryAction={
                  <IconButton
                    sx={{ marginRight: 0 }}
                    edge="end"
                    aria-label="expand"
                  >
                    <KeyboardArrowRightIcon />
                  </IconButton>
                }
                sx={{ marginY: ".625rem", paddingLeft: "1.5rem" }}
              >
                <ListItemText
                  primary={
                    <Typography variant="h5" marginBottom=".3125rem">
                      {item.attributes.parentModuleName}
                    </Typography>
                  }
                />
              </ListItem>

              <Collapse in={item.attributes.key === state.parentModule}>
                {item?.attributes.modules?.data.map((listItem) => (
                  <>
                    <ListItem
                      key={listItem.attributes.key}
                      onClick={() => {
                        handleFAQsClick(listItem.attributes.key, "module");
                        updateTitle("module", listItem.attributes.moduleName);
                      }}
                      sx={{ paddingLeft: "1.49rem" }}
                      secondaryAction={
                        <IconButton
                          sx={{ marginRight: 0 }}
                          edge="end"
                          aria-label="expand"
                        >
                          <KeyboardArrowRightIcon />
                        </IconButton>
                      }
                    >
                      <ListItemText
                        primary={
                          <Typography variant="h6" marginBottom=".3125rem">
                            {listItem.attributes.moduleName}
                          </Typography>
                        }
                      />
                    </ListItem>
                  </>
                ))}
              </Collapse>
              <Divider flexItem sx={{ color: "#77787B" }} />
            </React.Fragment>
          ))}
      </CommonMenuListPage>
    </>
  );

  const renderModuleView = () => (
    <>
      <CommonMenuListPage
        title="FAQs"
        handleBackBtnClick={handleBack} // Use handleBack instead of handleBackBtnClick
        pathname={pathname}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          paddingX="1.25rem"
        >
          <Divider className="header-text-line" />
          <Typography
            color="#77787B"
            fontSize=".75rem"
            fontWeight={500}
            marginX=".625rem"
          >
            {FAQsHeaderText.filter((name) => name !== "").join(" / ")}
          </Typography>
          <Divider className="header-text-line" />
        </Box>
        {FAQCategory.map((category) => (
          <React.Fragment key={category.attributes.key}>
            <ListItem
              onClick={() => {
                handleFAQsClick(category.attributes.key, "category");
                updateTitle("category", category.attributes.categoryName);
              }}
              secondaryAction={
                <IconButton
                  sx={{ marginRight: 0 }}
                  edge="end"
                  aria-label="expand"
                >
                  <KeyboardArrowRightIcon />
                </IconButton>
              }
              sx={{ marginY: ".625rem", paddingLeft: "1.5rem" }}
            >
              <ListItemText
                primary={
                  <Typography variant="h5" marginBottom=".3125rem">
                    {category.attributes.categoryName}
                  </Typography>
                }
              />
            </ListItem>
            <Divider flexItem sx={{ color: "#77787B" }} />
          </React.Fragment>
        ))}
      </CommonMenuListPage>
    </>
  );

  const renderCategoryView = () => (
    <>
      <CommonMenuListPage
        title="FAQs"
        handleBackBtnClick={handleBack} // Use handleBack instead of handleBackBtnClick
        pathname={pathname}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          paddingX="1.25rem"
        >
          <Divider className="header-text-line" />
          <Typography
            color="#77787B"
            fontSize=".75rem"
            fontWeight={500}
            marginX=".625rem"
          >
            {FAQsHeaderText.filter((name) => name !== "").join(" / ")}
          </Typography>
          <Divider className="header-text-line" />
        </Box>
        {answers.map((answer) => (
          <React.Fragment key={answer.id}>
            <ListItem
              onClick={() => showAnswer(answer.attributes)}
              secondaryAction={
                <IconButton
                  sx={{ marginRight: 0 }}
                  edge="end"
                  aria-label="expand"
                >
                  {state.question === answer.attributes.question ? (
                    <RemoveIcon />
                  ) : (
                    <AddIcon />
                  )}
                </IconButton>
              }
              sx={{ marginY: ".625rem", paddingLeft: "1.5rem" }}
            >
              <ListItemText
                primary={
                  <Typography variant="h5" marginBottom=".3125rem">
                    {answer.attributes.question}
                  </Typography>
                }
              />
            </ListItem>
            <Collapse in={state.question === answer.attributes.question}>
              <Box
                sx={{
                  paddingX: "2.25rem",
                  paddingY: "0.625rem",
                  fontSize: "16px",
                  "& td, & th": {
                    wordBreak: "break-word",
                    textAlign: "center",
                    border: "1px solid black",
                  },
                }}
                dangerouslySetInnerHTML={{ __html: answer.attributes.answer }}
              />
            </Collapse>
            <Divider flexItem sx={{ color: "#77787B" }} />
          </React.Fragment>
        ))}
      </CommonMenuListPage>
    </>
  );

  return (
    <>
      {(loading || isHlFetching) && (
        <CommonMenuListPage title="FAQs" pathname={pathname}>
          <CustomThreeDotsLoader />
        </CommonMenuListPage>
      )}
      {!loading && state.type === "parent-module" && renderParentModuleView()}
      {!loading &&
        !isHlFetching &&
        state.type === "module" &&
        renderModuleView()}
      {!loading &&
        !isHlFetching &&
        state.type === "category" &&
        renderCategoryView()}
    </>
  );
};

export default FAQs;
